import { Component, OnInit , Output, Input, EventEmitter} from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguagesService,AuthService, CandidatesService } from '../../../../services';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-language-modal',
    templateUrl: './language-modal.html',
    styleUrls: ['./language-modal.scss']
})

export class LanguageModalComponent implements OnInit {
    @Output() notifyParent = new EventEmitter<any>();
    @Input() isEdit  = false;
    @Input() language = {
        id :null ,
        language_id: null,
        writing : null,
        speaking : null,
        reading : null
    }
    @Input() selectedLanguages = [];
    languages = [] ;
    isLoading = false;
    viewLanguages = true;
    constructor(private toastr: ToastrService, private authService: AuthService,private location: PlatformLocation,public activeModal: NgbActiveModal, private languagesService : LanguagesService, private candidatesService: CandidatesService) {
    	location.onPopState(() => { this.activeModal.close();});
    }

    ngOnInit() {
        this.languagesService.getAll().subscribe((res: any) =>{this.languages = res.data;});
    }

    filterLanguages(){
        const result = this.languages.filter(r => !this.selectedLanguages.includes(r.id));
        if(result.length == 0)
            this.viewLanguages = false;
        else
            this.viewLanguages = true;
        return result;
    }

    checkLanguage(){
        this.filterLanguages();
        return this.viewLanguages;
    }

    closeModal(){
    	this.activeModal.close({status:true});
    }

    canAdd(){
        return this.isLoading || (this.language.language_id == null || this.language.writing == null || this.language.speaking == null || this.language.reading == null);
    }

    updateUserProfile(){
        var _ref = Object.assign({},this.language);
        this.isLoading = true;
        if(!this.isEdit)
            this.candidatesService.addLanguage(_ref,this.authService.user.candidate?.id).subscribe((res: any) =>{
                this.isLoading = false;
                this.language = {
                    id :null ,
                    language_id: null,
                    writing : null,
                    speaking : null,
                    reading : null
                };
                this.selectedLanguages.push(this.language.language_id);
                this.notifyParent.emit(true);
                this.closeModal();
            },(error:any)=>{
                this.isLoading = false;
                this.toastr.error(error.statusText, "update profile information");
            });
        else
            this.candidatesService.updateLanguage(_ref,this.authService.user.candidate?.id,this.language.id).subscribe((res: any) =>{
                this.isLoading = false;
                this.language = res.data;
                this.notifyParent.emit(true);
                this.closeModal();
            },(error:any)=>{
                this.isLoading = false;
                this.toastr.error(error.statusText, "update profile information");
            });
    }
}